import React, { useState, useMemo } from 'react';
import InspeccionSST from './components/InspeccionSST';
import HistorialSST from '../../gestionHumana/components/HistorialSST';
import ReporteIncidentesSST from './components/ReporteIncidentesSST';
import SubMenuFormatosSST from './components/SubMenuFormatosSST';
import AutoreporteSaludSST from './components/AutoreporteSaludSST';
import PanelCertificados from './components/PanelCertificados';
import FormularioMantenimientoSST from './components/FormularioMantenimientoSST';
import ProgramaCapacitaciones from './components/ProgramaCapacitaciones';
import SistemaGestionSST from './components/SistemaGestionSST'; 

export default function SeguridadSst({ usuario, onBackToMenu }) {
  const [vistaActual, setVistaActual] = useState('menu'); 

  const cambiarVista = (nuevaVista) => {
    window.scrollTo(0, 0);
    setVistaActual(nuevaVista);
  };

  const permisosABAC = useMemo(() => {
    try {
      const parsed = typeof usuario?.permisos_avanzados === 'string' 
        ? JSON.parse(usuario.permisos_avanzados) 
        : (usuario?.permisos_avanzados || {});
      return parsed.micros || parsed; 
    } catch (e) { return {}; }
  }, [usuario]);

  const cargoUpper = String(usuario?.cargo || "").toUpperCase();
  const esAdmin = cargoUpper.includes("SUPER");

  const checkPermiso = (nombreSubmodulo) => {
    if (esAdmin) return true;
    return permisosABAC[nombreSubmodulo] !== undefined;
  };

  const verInspeccion = checkPermiso('Inspección Locativa');
  const verSalud = checkPermiso('Autoreporte Salud');
  const verIncidentes = checkPermiso('Reporte de Eventos');
  const verPrograma = checkPermiso('Programa Capacitaciones');
  const verCertificados = checkPermiso('Certificados');
  const verMtto = checkPermiso('Mtto. de Equipos');
  const verOtros = checkPermiso('Otros Formatos SST');
  const verHistorial = checkPermiso('Historial General');
  const verSistemaGestion = checkPermiso('Sistema de Gestión'); 

  if (vistaActual === 'inspeccion') return <InspeccionSST usuario={usuario} filtroABAC={permisosABAC['Inspección Locativa']} onBack={() => cambiarVista('menu')} />;
  if (vistaActual === 'incidentes') return <ReporteIncidentesSST usuario={usuario} filtroABAC={permisosABAC['Reporte de Eventos']} onBack={() => cambiarVista('menu')} />;
  if (vistaActual === 'historial') return <HistorialSST usuario={usuario} filtroABAC={permisosABAC['Historial General']} onBack={() => cambiarVista('menu')} />;
  if (vistaActual === 'submodulo_extra') return <SubMenuFormatosSST usuario={usuario} filtroABAC={permisosABAC['Otros Formatos SST']} onBack={() => cambiarVista('menu')} />;
  if (vistaActual === "salud") return <AutoreporteSaludSST usuario={usuario} filtroABAC={permisosABAC['Autoreporte Salud']} onBack={() => cambiarVista("menu")} />;
  if (vistaActual === 'mantenimiento') return <FormularioMantenimientoSST usuario={usuario} filtroABAC={permisosABAC['Mtto. de Equipos']} onBack={() => cambiarVista('menu')} />;
  if (vistaActual === 'capacitaciones_phva') return <ProgramaCapacitaciones usuario={usuario} filtroABAC={permisosABAC['Programa Capacitaciones']} onBack={() => cambiarVista('menu')} />;
  if (vistaActual === "certificados") return <PanelCertificados empleado={usuario} filtroABAC={permisosABAC['Certificados']} onBack={() => cambiarVista('menu')} />;
  if (vistaActual === 'sistema_gestion') return <SistemaGestionSST usuario={usuario} filtroABAC={permisosABAC['Sistema de Gestión']} onBackToMenu={() => cambiarVista('menu')} />;

  const sinPermisosSST = !verInspeccion && !verSalud && !verIncidentes && !verPrograma && !verCertificados && !verMtto && !verOtros && !verHistorial && !verSistemaGestion;

  // Renderizador estandarizado de tarjetas (SaaS Elegante)
  const TarjetaModulo = ({ onClick, icono, badge, titulo, desc, color }) => (
    <div onClick={onClick} className="bg-white/60 hover:bg-white/90 backdrop-blur-xl rounded-[28px] p-6 sm:p-8 border border-white/80 shadow-lg hover:shadow-xl transition-all cursor-pointer group flex flex-col items-start text-left card-hover glass-reflection animate-fade-in-up">
      <div className="flex justify-between items-start w-full mb-5">
        <div className={`w-14 h-14 bg-${color}-50/80 rounded-2xl flex items-center justify-center text-3xl shadow-inner border border-${color}-100 icon-bounce`}>
          {icono}
        </div>
        <span className={`bg-${color}-100/80 text-${color}-700 text-[10px] font-black px-3 py-1.5 rounded-full uppercase tracking-wider shadow-sm border border-${color}-200/50`}>
          {badge}
        </span>
      </div>
      <h3 className="text-lg font-black text-slate-800 mb-1.5 leading-tight">{titulo}</h3>
      <p className="text-xs text-slate-500 font-bold leading-relaxed">{desc}</p>
    </div>
  );

  return (
    <div className="w-full min-h-screen py-6 px-4 flex flex-col items-center">
      <div className="bg-white/40 backdrop-blur-[45px] rounded-[36px] shadow-[0_20px_50px_rgba(0,0,0,0.1)] max-w-7xl w-full mx-auto border border-white/80 animate-fade-in relative overflow-hidden flex flex-col p-6 sm:p-10">
        
        <div className="flex items-center gap-5 mb-10 pb-6 border-b border-slate-200/50 animate-fade-in-down">
          <button 
            onClick={onBackToMenu}
            className="w-14 h-14 flex-none bg-white hover:bg-slate-50 text-slate-700 flex items-center justify-center rounded-2xl transition-all shadow-sm border border-slate-200 cursor-pointer"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M15 19l-7-7 7-7"></path></svg>
          </button>
          <div>
            <h1 className="text-3xl font-black text-slate-800 tracking-tight">Seguridad y Salud en el Trabajo</h1>
            <p className="text-sm font-bold text-slate-500 mt-1">Selecciona el proceso que deseas realizar</p>
          </div>
        </div>

        {sinPermisosSST ? (
          <div className="p-12 text-center bg-white/60 backdrop-blur-xl border border-white/80 rounded-[32px] shadow-xl animate-fade-in-up">
            <span className="text-6xl block mb-6 drop-shadow-md">🛡️</span>
            <h3 className="text-2xl font-black text-slate-800">Módulo Bloqueado</h3>
            <p className="text-sm text-slate-500 font-bold mt-2">No tienes formularios de SST asignados en tu matriz de privilegios ABAC.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {verSistemaGestion && <TarjetaModulo onClick={() => cambiarVista('sistema_gestion')} icono="📂" badge="DOC" titulo="Sistema de Gestión" desc="Archivos oficiales, PDFs e imágenes del SG-SST." color="blue" />}
            {verInspeccion && <TarjetaModulo onClick={() => cambiarVista('inspeccion')} icono="📋" badge="FT-06" titulo="Inspección Locativa" desc="Evaluación de instalaciones, orden y aseo." color="blue" />}
            {verSalud && <TarjetaModulo onClick={() => cambiarVista('salud')} icono="🩺" badge="FT-05" titulo="Autoreporte Salud" desc="Reporte de condiciones de salud y síntomas." color="indigo" />}
            {verIncidentes && <TarjetaModulo onClick={() => cambiarVista('incidentes')} icono="⚠️" badge="FT-11" titulo="Reporte de Eventos" desc="Reporte de incidentes y actos inseguros." color="amber" />}
            {verPrograma && <TarjetaModulo onClick={() => cambiarVista('capacitaciones_phva')} icono="📚" badge="PG-01" titulo="Capacitaciones" desc="Cronograma PHVA, ejecución y cumplimiento." color="blue" />}
            {verCertificados && <TarjetaModulo onClick={() => cambiarVista('certificados')} icono="🎓" badge="SINC" titulo="Certificados" desc="Sincroniza Conceptos y Alimentos." color="teal" />}
            {verMtto && <TarjetaModulo onClick={() => cambiarVista('mantenimiento')} icono="🔧" badge="MTO" titulo="Mtto. de Equipos" desc="Registro y estado de equipos del PDV." color="orange" />}
            {verOtros && <TarjetaModulo onClick={() => cambiarVista('submodulo_extra')} icono="📂" badge="EXTRAS" titulo="Otros Formatos" desc="Permisos, EPP, pausas activas y más." color="purple" />}
            {verHistorial && <TarjetaModulo onClick={() => cambiarVista('historial')} icono="🗂️" badge="AUDIT" titulo="Historial General" desc="Consulta y audita los formularios guardados." color="emerald" />}
          </div>
        )}
      </div>
    </div>
  );
}